<template>
  <ElasticSearch :config="config" />
</template>

<script>
import ElasticSearch from "../../components/ElasticSearch/ElasticSearch.vue";

export default {
  name: "app",
  components: {
    ElasticSearch
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
